import { useEffect, useState } from 'react';

/** True when the viewport is too small to meaningfully display the 1366×1024
 *  iPad-cockpit frame — i.e. any phone, small tablet in portrait, or a tight
 *  browser window on a laptop. Tracks orientation changes live. */
export function useIsCompact(breakpoint = 900): boolean {
  const [compact, setCompact] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < breakpoint;
  });

  useEffect(() => {
    const compute = () => setCompact(window.innerWidth < breakpoint);
    compute();
    window.addEventListener('resize', compute);
    window.addEventListener('orientationchange', compute);
    return () => {
      window.removeEventListener('resize', compute);
      window.removeEventListener('orientationchange', compute);
    };
  }, [breakpoint]);

  return compact;
}
